import {
  CartSettings,
  InjectedCartProps,
  withCartFactory,
} from '@grandvisionhq/www-next/pages/cart/hoc'

export const settings: CartSettings = {
  isDiscountCodeEnabled: true,
  maximumQuantity: 5,
  shouldShowCartDiscountOnLineItem: true,
  shouldShowSubTotal: true,
  shouldShowTotalDiscount: true,
  onFinalizedCartError: ({ resetCallback }: { resetCallback: () => void }) => {
    resetCallback()
  },
  onUnRecoverableError: ({ resetCallback }: { resetCallback: () => void }) => {
    resetCallback()
  },
}

export type { InjectedCartProps }

export const withCart = withCartFactory(settings)
